import { Injectable } from '@angular/core';
import { endOfApiScale, startOfApiScale } from '@library/store/measures/measures';
import { EnumApiScales, TimeRange } from '@library/store/measures/measures.interface';
import { Module } from '@library/store/modules/modules.interface';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { EnergyReport } from '@store/energy-reports/energy-reports.interface';
import * as moment from 'moment-timezone';
import { BehaviorSubject, ReplaySubject, firstValueFrom } from 'rxjs';

@Injectable()
export class ControlPageReportsService {

  reportDevice$ = new ReplaySubject<Module>(1);
  timeRange$ = new BehaviorSubject<TimeRange>(null);

  constructor(
    private reportsFacade: EnergyReportsFacade,
  ) {
  }

  async loadReport(device_id: string, month: number, year: number) {
    const action = await firstValueFrom(this.reportsFacade.loadEnergyReports({month, year, device_id}));
    this.reportsFacade.selectReport(action.report as EnergyReport);
  }

  hasNextBilan(report: EnergyReport, currentDevice: Module) {
    if (!currentDevice) {
      return false;
    }
    else {
      return moment().month(report.month -1).year(report.year) < moment().month(currentDevice?.last_energy_bilan_month -1).year(currentDevice.last_energy_bilan_year);
    }
  }

  setTimerange(month: number, year: number) {
    this.timeRange$.next({
      dateBegin: startOfApiScale(moment().month(month -1).year(year), EnumApiScales.ONE_DAY),
      dateEnd: endOfApiScale(moment().month(month -1).year(year), EnumApiScales.ONE_DAY),
    });
  }

}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getMonthText(month: number, year: number) {
  return capitalizeFirstLetter(moment().month(month - 1).year(year).format('MMMM'));
}

export function getCurrentMonth() {
  return moment().month();
}
export function getCurentYear() {
  return moment().year();
}
